// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3doh1","index":"styles_index__3I370"};